import React from 'react';

export function BasicErrorComponent({error}) {

    if(error != null) {
        return (
            <div className="alert alert-danger mt-3" role="alert">
                {/*<h5 className={"fw-bold"}>{error.exceptionType}</h5>*/}
                <p>{error.message}</p>
            </div>
        )
    }

}